import { create } from "../../../common/utils/zustand_state_manager";
import { useAuditorRepositories } from "./use_repositories";
import { IGetAllAuditorAuditoresUseCase } from "../../../features/auditoria/presentation/useCases/read/get_all_auditor_auditores_use_case";
import { GetAllAuditorAuditoresServicoUseCase } from "../../../features/auditoria/domain/useCases/read/get_all_auditor_auditores_use_case";
import { ICreateAuditoresUseCase } from "../../../features/auditoria/presentation/useCases/create/create_auditores_servicos_use_case";
import { CreateAuditoresUseCase } from "../../../features/auditoria/domain/useCases/create/create_auditores_use_case";
import { IUpdateAuditoresUseCase } from "../../../features/auditoria/presentation/useCases/update/update_auditores_servicos_use_case";
import { UpdateAuditoresUseCase } from "../../../features/auditoria/domain/useCases/update/update_auditores_use_case";
import { IDeleteAuditoresUseCase } from "../../../features/auditoria/presentation/useCases/delete/delete_auditores_servicos_use_case";
import { DeleteAuditoresUseCase } from "../../../features/auditoria/domain/useCases/delete/delete_auditores_use_case";
import { IGetAllAuditorAuditoriasUseCase } from "../../../features/auditoria/presentation/useCases/read/get_all_auditor_auditorias_use_case";
import { GetAllAuditoriasAuditoriasServicoUseCase } from "../../../features/auditoria/domain/useCases/read/get_all_auditor_auditorias_use_case";
import { ICreateAuditoriaUseCase } from "../../../features/auditoria/presentation/useCases/create/create_auditoria_servicos_use_case";
import { CreateAuditoriaUseCase } from "../../../features/auditoria/domain/useCases/create/create_auditoria_use_case";
import { ICreateProcessoAuditoriaUseCase } from "../../../features/auditoria/presentation/useCases/create/create_processo_auditoria_servicos_use_case";
import { CreateProcessoAuditoriaUseCase } from "../../../features/auditoria/domain/useCases/create/create_processo_auditoria_use_case";
import { IGetAllAuditorProcessoAuditoriasUseCase } from "../../../features/auditoria/presentation/useCases/read/get_all_auditor_processo_auditorias_use_case";
import { GetAllAuditoriasProcessoAuditoriasServicoUseCase } from "../../../features/auditoria/domain/useCases/read/get_all_auditor_processo_auditorias_use_case";
import { UpdateAuditoriaUseCase } from "../../../features/auditoria/domain/useCases/update/update_auditoria_use_case";
import { IUpdateAuditoriaUseCase } from "../../../features/auditoria/presentation/useCases/update/update_auditoria_servicos_use_case";
import { IDeleteAuditoriaUseCase } from "../../../features/auditoria/presentation/useCases/delete/delete_auditoria_servicos_use_case";
import { DeleteAuditoriaUseCase } from "../../../features/auditoria/domain/useCases/delete/delete_auditoria_use_case";
import { IUpdateProcessoAuditoriaUseCase } from "../../../features/auditoria/presentation/useCases/update/update_processo_auditoria_servicos_use_case";
import { UpdateProcessoAuditoriaUseCase } from "../../../features/auditoria/domain/useCases/update/update_processo_auditoria_use_case";
import { IDeleteProcessoAuditoriaUseCase } from "../../../features/auditoria/presentation/useCases/delete/delete_processo_auditoria_servicos_use_case";
import { DeleteProcessoAuditoriaUseCase } from "../../../features/auditoria/domain/useCases/delete/delete_processo_auditoria_use_case";
import { ICopiaAuditoriaUseCase } from "../../../features/auditoria/presentation/useCases/create/copia_auditoria_use_case";
import { CopiaAuditoriaUseCase } from "../../../features/auditoria/domain/useCases/create/copia_auditoria_use_case";
import { IGetArquivoAuditoresUseCase } from "../../../features/auditoria/presentation/useCases/read/get_arquivo_auditores_use_case";
import { GetArquivoAuditoresUseCase } from "../../../features/auditoria/domain/useCases/read/get_arquivo_auditores_use_case";
import { IGetAllIndicadoresUseCase } from "../../../features/auditoria/presentation/useCases/read/get_all_auditor_indicadores_use_case";
import { GetAllIndicadoresUseCase } from "../../../features/auditoria/domain/useCases/read/get_all_auditor_indicador_use_case";
import { CopiaProcessoAuditoriaUseCase } from "../../../features/auditoria/domain/useCases/create/copia_processo_auditoria_use_case";
import { ICopiaProcessoAuditoriaUseCase } from "../../../features/auditoria/presentation/useCases/create/copia_processo_auditoria_use_case";
import { IGetArquivoAuditoriaUseCase } from "../../../features/auditoria/presentation/useCases/read/get_arquivo_auditoria_use_case";
import { GetArquivoAuditoriaUseCase } from "../../../features/auditoria/domain/useCases/read/get_arquivo_auditoria_use_case";


export type AuditorState = {
  getAllListagemAuditoresUseCase: IGetAllAuditorAuditoresUseCase,
  createAuditoresUseCase: ICreateAuditoresUseCase,
  updateAuditorUseCase: IUpdateAuditoresUseCase,
  deleteAuditoresUseCase: IDeleteAuditoresUseCase,
  getArquivoAuditoresUseCase: IGetArquivoAuditoresUseCase,

  //#region Auditorias
  getAllListagemAuditoriaUseCase: IGetAllAuditorAuditoriasUseCase
  createAuditoriaUseCase: ICreateAuditoriaUseCase,
  updateAuditoriaUseCase: IUpdateAuditoriaUseCase,
  deleteAuditoriaUseCase: IDeleteAuditoriaUseCase,
  copiaAuditoriaUseCase: ICopiaAuditoriaUseCase,
  getArquivoAuditoriaUseCase: IGetArquivoAuditoriaUseCase,

  //#endregion

  //#region Processo Auditoria
  createProcessoAuditoriaUseCase: ICreateProcessoAuditoriaUseCase,
  getAllListagemProcessoAuditoriaUseCase: IGetAllAuditorProcessoAuditoriasUseCase
  updateProcessoAuditoriaUseCase: IUpdateProcessoAuditoriaUseCase,
  deleteProcessoAuditoriaUseCase: IDeleteProcessoAuditoriaUseCase,
  copiaProcessoAuditoriaUseCase: ICopiaProcessoAuditoriaUseCase,

  //#endregion

  //#region Principal
  getAllIndicadoresUseCase: IGetAllIndicadoresUseCase,

  //#endregion





}
export const useAuditorUseCases = create<AuditorState>(() => {
  const { auditorRepository: repository } = useAuditorRepositories.getState();
  return {
    getAllListagemAuditoresUseCase: new GetAllAuditorAuditoresServicoUseCase(repository),
    createAuditoresUseCase: new CreateAuditoresUseCase(repository),
    updateAuditorUseCase: new UpdateAuditoresUseCase(repository),
    deleteAuditoresUseCase: new DeleteAuditoresUseCase(repository),
    copiaAuditoriaUseCase: new CopiaAuditoriaUseCase(repository),
    getArquivoAuditoresUseCase: new GetArquivoAuditoresUseCase(repository),

    //#region Auditorias
    getAllListagemAuditoriaUseCase: new GetAllAuditoriasAuditoriasServicoUseCase(repository),
    createAuditoriaUseCase: new CreateAuditoriaUseCase(repository),
    updateAuditoriaUseCase: new UpdateAuditoriaUseCase(repository),
    deleteAuditoriaUseCase: new DeleteAuditoriaUseCase(repository),
    getArquivoAuditoriaUseCase: new GetArquivoAuditoriaUseCase(repository),

    //#endregion

    //#region Processo Auditoria
    createProcessoAuditoriaUseCase: new CreateProcessoAuditoriaUseCase(repository),
    getAllListagemProcessoAuditoriaUseCase: new GetAllAuditoriasProcessoAuditoriasServicoUseCase(repository),
    updateProcessoAuditoriaUseCase: new UpdateProcessoAuditoriaUseCase(repository),
    deleteProcessoAuditoriaUseCase: new DeleteProcessoAuditoriaUseCase(repository),
    copiaProcessoAuditoriaUseCase: new CopiaProcessoAuditoriaUseCase(repository),
    //#endregion

    //#region Principal
    getAllIndicadoresUseCase: new GetAllIndicadoresUseCase(repository),

    //#endregion

  };
});